import { takeLatest } from 'redux-saga/effects';
import {
  GET_CHART_OF_ACCOUNTS_TEMPLATES_REQUEST,
  FETCH_CHART_OF_ACCOUNTS_BY_COUNTRY_REQUEST,
  SAVE_CHART_OF_ACCOUNTS_REQUEST,
  SAVE_CHART_OF_ACCOUNTS_TEMPLATE_REQUEST,
  FETCH_CHART_OF_ACCOUNTS_FOR_ORGANISATION_REQUEST,
  DELETE_CHART_OF_ACCOUNT_ROW_REQUEST,
  DELETE_CHART_OF_ACCOUNTS_TEMPLATE_REQUEST,
  CREATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_REQUEST,
  UPDATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_REQUEST,
  UPDATE_CHART_OF_ACCOUNTS_TEMPLATE_NAME_REQUEST,
} from '../constants';
import { fetchChartOfAccountsTemplatesSaga } from './fetchChartOfAccountsTemplatesSaga';
import { fetchChartOfAccountsByCountrySaga } from './fetchChartOfAccountsByCountrySaga';
import { saveChartOfAccountsSaga } from './saveChartOfAccountsSaga';
import { fetchChartOfAccountsForOrganisationSaga } from './fetchChartOfAccountsForOrganisationSaga';
import { deleteChartOfAccountRowSaga } from './deleteChartOfAccountRowSaga';
import { saveChartOfAccountsTemplateSaga } from './saveChartOfAccountsTemplateSaga';
import { deleteChartOfAccountsTemplateSaga } from './deleteChartOfAccountsTemplateSaga';
import { createChartOfAccountsCustomRowSaga } from './createChartOfAccountsCustomRowSaga';
import { updateChartOfAccountsCustomRowSaga } from './updateChartOfAccountsCustomRowSaga';
import { updateChartOfAccountsTemplateNameSaga } from './updateChartOfAccountsTemplateNameSaga';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundARY-TYPES */
export function* chartOfAccountsSaga() {
  yield takeLatest(
    GET_CHART_OF_ACCOUNTS_TEMPLATES_REQUEST,
    fetchChartOfAccountsTemplatesSaga
  );
  yield takeLatest(
    SAVE_CHART_OF_ACCOUNTS_REQUEST,
    saveChartOfAccountsSaga
  );
  yield takeLatest(
    SAVE_CHART_OF_ACCOUNTS_TEMPLATE_REQUEST,
    saveChartOfAccountsTemplateSaga
  );
  yield takeLatest(
    FETCH_CHART_OF_ACCOUNTS_FOR_ORGANISATION_REQUEST,
    fetchChartOfAccountsForOrganisationSaga
  );
  yield takeLatest(
    FETCH_CHART_OF_ACCOUNTS_BY_COUNTRY_REQUEST,
    fetchChartOfAccountsByCountrySaga
  );
  yield takeLatest(
    DELETE_CHART_OF_ACCOUNT_ROW_REQUEST,
    deleteChartOfAccountRowSaga
  );
  yield takeLatest(
    DELETE_CHART_OF_ACCOUNTS_TEMPLATE_REQUEST,
    deleteChartOfAccountsTemplateSaga
  );
  yield takeLatest(
    CREATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_REQUEST,
    createChartOfAccountsCustomRowSaga
  );
  yield takeLatest(
    UPDATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_REQUEST,
    updateChartOfAccountsCustomRowSaga
  );
  yield takeLatest(
    UPDATE_CHART_OF_ACCOUNTS_TEMPLATE_NAME_REQUEST,
    updateChartOfAccountsTemplateNameSaga
  );
}
